"use client";

import { LocalizedJoi } from "@/utils/localized-joi";
import type Joi from "joi";
import type { ValidationResult } from "joi";
import { type ChangeEvent, type KeyboardEvent, useState } from "react";

import { EyeIcon, EyeSlashIcon } from "@/components/icons/icons";
import { InputErrorMessage } from "./input-error-message";
import { InputWrapper } from "./input-wrapper";
import type { InputBaseProps } from "./input.model";

interface InputPasswordProps extends InputBaseProps {
  externalValidationError?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  validationSchema?: Joi.StringSchema;
  value?: string;
}

export const InputPassword = ({
  disabled,
  id,
  labelledBy,
  name,
  onBlur,
  onChange,
  placeholder,
  required,
  value,
  externalValidationError,

  validationSchema = required
    ? LocalizedJoi.string().label("Passord").required()
    : LocalizedJoi.string().label("Passord").allow(""),
}: InputPasswordProps) => {
  const [validationError, setValidationError] = useState<ValidationResult<string> | undefined>();

  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <InputWrapper>
      <input
        aria-labelledby={labelledBy}
        className="input input--password"
        disabled={disabled}
        id={id}
        name={name}
        onBlur={(e) => {
          if (onBlur) {
            onBlur();
          }
          setValidationError(validationSchema.validate(e.target.value));
        }}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        type={showPassword ? "text" : "password"}
        value={value}
      />

      {/* click on eye icon to toggle password visibility */}
      <button
        aria-label="Vis passord"
        className="input-adornment"
        onKeyDown={(e: KeyboardEvent) => e.key === "Enter" && setShowPassword(!showPassword)}
        onClick={() => setShowPassword(!showPassword)}
        type="button"
      >
        {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
      </button>

      <InputErrorMessage
        errorMessage={validationError?.error?.message}
        externalErrorMessage={externalValidationError}
      />
    </InputWrapper>
  );
};
